<template>
  <v-container fluid pa-0>
    <v-item-group :value="innerValue"
                  @change="emitValue($event)"
    >

      <v-row justify="center">
        <v-col :key="item.id"
               cols="2"
               v-for="(item) in items"
        >
          <v-item :value="item[valueKey]"
                  class="fill-height"
                  v-slot:default="{ active, toggle }"
          >
            <v-hover class="fill-height">
              <template v-slot="{ hover }">
                <v-card :color="active ? 'primary' : ''"
                        :elevation="hover ? 24 : ''"
                        :style="{'box-shadow': active ? '0 0 0 1px white !important' : '0 0 0 0px white !important'}"
                        @click="toggle"
                        class="fill-height"
                        light
                >
                  <v-card-text :style="{ 'color': active ? 'white' : 'black' }"
                               class="text-capitalize fill-height"
                               style="display: flex; align-items: center; justify-content: center;"
                  >{{ item[labelKey] }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-item>
        </v-col>
      </v-row>
    </v-item-group>
  </v-container>
</template>

<script>
    export default {
        name: "Likert",
        props: {
            items: {
                required: true,
                type: Array
            },
            valueKey: {
                default: 'value'
            },
            labelKey: {
                default: 'label'
            },
            value: {
                required: true
            }
        },
        computed: {},
        data: () => ({
            innerValue: null,
        }),
        methods: {
            cloneInner() {
                this.innerValue = this.value;
            },
            emitValue(event) {
                this.innerValue = event;
                if (this.innerValue !== this.value) {
                    this.$emit('input', this.innerValue);
                }
            }
        },
        mounted() {
            this.cloneInner();
        },
        watch: {
            value() {
                this.cloneInner();
            }
        }
    }
</script>

<style scoped>

</style>